/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Complete helper functions for generating Lua for
 *     blocks.  This is the entrypoint for lua_compressed.js.
 * @suppress {extraRequire}
 */
'use strict';

goog.module('Blockly.Lua.all');

const moduleExports = goog.require('Blockly.Lua');
goog.require('Blockly.Lua.colour');
goog.require('Blockly.Lua.lists');
goog.require('Blockly.Lua.logic');
goog.require('Blockly.Lua.loops');
goog.require('Blockly.Lua.math');
goog.require('Blockly.Lua.procedures');
goog.require('Blockly.Lua.texts');
goog.require('Blockly.Lua.variables');
goog.require('Blockly.Lua.variablesDynamic');

exports = moduleExports;
